import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/search/flight/santsg',
    name: 'flight-santsg',
    component: () => import('../views/flight/santsg/agency/index.vue'),
    meta: { 
        layout: appLayout,
        mode: 'flight'
     }
  }, {
    path: '/flight/santsg/avail/:type?',
    name: 'flight-avail-santsg',
    component: () => import('../views/flight/santsg/agency/avail.vue'),
    meta: { 
        layout: appLayout,
        mode: 'flight'
     }
  }, {
    path: '/flight/santsg/options/:id?/:type?',
    name: 'flight-options-santsg',
    component: () => import('../views/flight/santsg/agency/Options.vue'),
    meta: {
      layout: appLayout,
      mode: 'flight'
    }
  }, {
    path: '/flight/reserve/santsg/:type?',
    name: 'flight-reserve-santsg',
    component: () => import('../views/flight/santsg/agency/reserve.vue'),
    meta: {
      layout: appLayout,
      mode: 'flight'
    }
  },
]

